import { AutoMap } from "@automapper/classes";
import { ReferenceClassificationsDto } from "./reference-classifications.dto";

export class ReferenceClassificationsResponseDto {

    @AutoMap()
  public content!: ReferenceClassificationsDto[];

}